// extracted by css-extract-rspack-plugin
export default {"cls1":"YourPaperCard-cls1_5IX","cls2":"YourPaperCard-cls2_OK3 YourPaperCard-cls1_5IX"};